<template>
  <div class="relative border rounded-lg shadow-lg m-2 transition bg-white" v-if="product.active==1"
       @touchstart="toggleAnimation($event)" @touchend="toggleAnimation($event)">
    <img :src="product.photo.path" alt="">

    <div class="m-2 text-sm text-center">
      <span>{{ product.name }}</span>

      <div class="text-gray-400 mt-1 text-xs">{{ `${$t('stock')}: ${product.inventory} ${$t('unit')}` }}</div>

      <div class="mt-2">
        <span class="text-yellow-500 font-bold">{{ $helper.priceFormatter(product.price, false) }}</span>
        {{ $t('toman') }}
      </div>

      <div class="absolute bg-yellow-500 top-0 right-0 p-2 rounded-bl-lg rounded-tr-lg" v-if="count">
        {{ count }}
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: "VerticalProductCard",
  props: ['product'],
  computed: {
    count() {
      return this.$store.getters.productCount(this.product.id)
    }
  },
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('scale-95')
      event.currentTarget.classList.toggle('shadow-lg')
    }
  }
}
</script>

<style scoped>

</style>